import { render, staticRenderFns } from "./SendByLink.vue?vue&type=template&id=11748e77&scoped=true&lang=pug"
import script from "./SendByLink.vue?vue&type=script&lang=js"
export * from "./SendByLink.vue?vue&type=script&lang=js"
import style0 from "./SendByLink.vue?vue&type=style&index=0&id=11748e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11748e77",
  null
  
)

export default component.exports